/* @flow */
import React from 'react';
import ConnectedBankAccount from 'entities/ConnectedBankAccount';
import Menu from 'components/Menu.jsx';
import MenuItem from 'components/MenuItem.jsx';
import Glyph from 'components/Glyph.jsx';
import ConnectedBankAccountActions from 'payments/actions/ConnectedBankAccountActions';
import ToastActions from 'actions/ToastActions';
import MenuButton from 'components/MenuButton.jsx';
import Text from 'components/Text.jsx';

import 'payments/components/styles/LinkedAccountsTableRow.scss';

export default class LinkedAccountsTableRow extends React.Component {
  static propTypes = {
    bankAccount: React.PropTypes.instanceOf(ConnectedBankAccount).isRequired,
  }

  revokeAccess() {
    ConnectedBankAccountActions.revokeAccess(this.props.bankAccount).then(
      () => ToastActions.showSuccessToast('Bank account revoked'),
      () => ToastActions.showErrorToast('Bank account revoke failed')
    )
    .then(() => ConnectedBankAccountActions.load());
  }

  renderMenuButton() {
    const menu = (
      <Menu>
        <MenuItem onClick={() => this.revokeAccess()}>
          <Glyph color="lava" name="trash" />
          <Text color="lava">
            Revoke approval
          </Text>
        </MenuItem>
      </Menu>
    );

    return (
      <MenuButton
        alignment="right"
        placement="bottom"
        menu={menu}
        size="xsmall"
        level="secondary">
        <Glyph name="ellipses" solo />
      </MenuButton>
    );
  }

  render() {
    const { bankAccount } = this.props;
    const externalAccount = bankAccount.getExternalAccount();

    return (
      <tr className="LinkedAccountsTableRow">
        <td>
          {bankAccount.getConnectedUserName()}
        </td>
        <td>
          <div className="LinkedAccountsTableRow-actions">
            <div>
              {externalAccount ?
                externalAccount.getName() :
                'No bank name given'
              }
            </div>
            <div>
              {this.renderMenuButton()}
            </div>
          </div>
        </td>
      </tr>
    );
  }
}



// WEBPACK FOOTER //
// ./src/payments/components/LinkedAccountsTableRow.jsx